import React from 'react';
import { Box, Typography, Container, Paper, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

const BrandLanding = () => {
    const navigate = useNavigate();

    return (
        <Container maxWidth="lg" sx={{ py: { xs: 4, md: 8 } }}>
            <Button
                variant="contained"
                endIcon={<ArrowForwardIcon />}
                onClick={() => navigate('/dashboard')}
                sx={{ mb: 4, borderRadius: 2, px: 3, py: 1 }}
            >
                Access Application
            </Button>

            <Paper
                elevation={0}
                sx={{
                    p: { xs: 4, md: 8 },
                    textAlign: 'center',
                    borderRadius: 4,
                    bgcolor: 'white',
                    border: '1px solid',
                    borderColor: 'divider',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: 4,
                    animation: 'fadeIn 0.8s ease-out'
                }}
            >
                <Box
                    component="img"
                    src="/logo-spicy.png"
                    alt="Spicy Aliyadans Hybrid Logo"
                    sx={{
                        width: { xs: 250, md: 400 },
                        height: 'auto',
                        filter: 'drop-shadow(0 20px 40px rgba(0,0,0,0.1))',
                        transition: 'transform 0.5s ease',
                        '&:hover': {
                            transform: 'scale(1.05)'
                        }
                    }}
                />

                <Box>
                    <Typography variant="h3" fontWeight={900} color="primary.main" gutterBottom sx={{ letterSpacing: -1 }}>
                        SPICY ALIYADANS
                    </Typography>
                    <Typography variant="h5" color="text.secondary" fontWeight={600} sx={{ mb: 2 }}>
                        Modern Agri-Tech Vertical Farming
                    </Typography>
                    <Box sx={{
                        width: 60,
                        height: 4,
                        bgcolor: 'secondary.main',
                        mx: 'auto',
                        borderRadius: 2,
                        mb: 4
                    }} />

                    <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 600, mx: 'auto', lineHeight: 1.8, fontSize: '1.1rem' }}>
                        Transforming the future of black pepper cultivation through innovative
                        PVC vertical farming technology. Built on the strength of partnership,
                        precision, and a passion for premium agricultural excellence.
                    </Typography>
                </Box>

                <Box sx={{ display: 'flex', gap: 4, mt: 4, flexWrap: 'wrap', justifyContent: 'center' }}>
                    {[
                        { label: '4 Partners', sub: 'Aliyadans' },
                        { label: 'Vertical Tech', sub: 'PVC Helix' },
                        { label: 'Premium Quality', sub: 'Black Pepper' }
                    ].map((feat, i) => (
                        <Box key={i} sx={{ textAlign: 'center' }}>
                            <Typography variant="h5" fontWeight={800} color="text.primary">
                                {feat.label}
                            </Typography>
                            <Typography variant="caption" color="text.secondary" fontWeight={700} sx={{ textTransform: 'uppercase' }}>
                                {feat.sub}
                            </Typography>
                        </Box>
                    ))}
                </Box>
            </Paper>
        </Container>
    );
};

export default BrandLanding;
